<template>
    <div class="z-start-task">
        <div class="header">
            <el-checkbox class="checkbox" v-model="check_all" @change="checkAll" fill="#01b6ad"></el-checkbox>
            <span style="margin-right:15px;">已选择
                <span class="selected_num">{{ delete_ids.length }}</span>
            </span>
            <div @click.stop.prevent="deleteItem" class="front-btn red" :class="{disabled:delete_ids.length == 0}">删除</div>
            <div @click.stop.prevent="createTask" class="front-btn green" :class="{disabled:!created_flag}">创建</div>
        </div>
    
        <listWrap @refresh="refresh" @choose="same" :idStr="delete_str" :data="data" :config="config" :keyStatus="key_status" ></listWrap>
        <z-pagination @getPage="refresh" :data='data'></z-pagination>
    </div>
</template>

<script type="text/ecmascript-6">
    import listWrap from "src/components/tasklistTpl.vue"
    import { mapState } from "vuex";

    export default {
        components: {
            listWrap,
        },
        data() {
            return {
                data: {},  //放页面数据的
                created_flag:false,

                key_status: 10,
                config: {
                    source_type: 0,
                    template_id: 0,
                    process_status: 0,
                },
                check_all:false,  //全选   
                delete_ids:[],   //删除的任务id合集
            }

        },
        computed: {
            ...mapState({
                seachKeyWord: state => state.search.keyword
            }),
            delete_str(){  //删除的id str
                return this.delete_ids.join(",");
            },
            max_ids(){  //当前页 所有可选任务id合集
                return this.data.list?this.data.list.filter(item=>{
                    return item.category_status!=10 || item.process_status !=102;
                }).map(item=>{
                    return item.id;
                }):[];
            },
            
        },
        watch: {
            delete_ids(arr){
                let maxLen = this.max_ids.length;
                if(maxLen == 0){
                    this.check_all = false;
                    return;
                }
                this.check_all = arr.length === maxLen;
            }
        },

        created() {
            this.$func.getUserBu(true,BU=>{  //获取登录用户BU
                this.created_flag = BU.pub_template_ids != "";
            });   
            this.refresh();
        },

        // mounted() {
        //     this.$store.dispatch('getSearchTip', "搜索任务名称/编号...");
        // },

        methods: {
            refresh(page) {   //获取列表
                let obj = {
                    ...this.config,
                    page:page,
                    keyword: this.seachKeyWord
                };
                this.getData(obj);   
            },
            getData(obj){  //拉取数据
                let url = `api/clerk/task/start_list_page`;
                this.$http.get(url, {params:obj}).then(res => {
                    console.log("发布任务列表");
                    if(res.status == 200){
                        this.data = res.res_data;
                        this.delete_ids = [];   
                    }
                });
            },


            // ****按钮操作
            createTask() {  //创建任务
                if(!this.created_flag){
                    this.$message({
                        message: "您所在BU没有发布范围",
                        type: 'warning'
                    });
                    return;
                };

                let id = this.$crypto.encrypt(0);
                this.$router.push({
                    name: `task-detail`,
                    params: {
                        task_id: id,
                    }
                });
            }, 
                    
            deleteItem() { //删除列表数据
                let str = this.delete_str;
                if(str){
                    this.$http.delete('api/clerk/task', {
                        data: { 'ids': str }
                    }).then(res => {
                        if (res.status == 200) {
                            this.delete_ids = [];    
                            this.refresh(this.data.current_page);
                            this.successTip("删除成功");
                        }

                        
                    });
                
                    // this.$message("请选择至少一项任务");
                }
        
            },  

            // changedata(data) {
            //     this.data = data;
            // },
            checkAll(event) {
                this.delete_ids = event.target.checked?[...this.max_ids]:[];
            },
            same(arr){
                this.delete_ids = arr;
            },        
        




        },


    };

</script>




<style lang="less">
@import "~src/assets/less/task.less";
</style>



// WEBPACK FOOTER //
// page-start.vue?817200e2